import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActivateSchoolMutationVariables = GraphQLTypes.Exact<{
  unitId: GraphQLTypes.Scalars['String']['input'];
}>;


export type ActivateSchoolMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'activateUnit'>
);


export const ActivateSchoolDocument = /*#__PURE__*/ gql`
    mutation activateSchool($unitId: String!) {
  activateUnit(unitId: $unitId)
}
    `;

/**
 * __useActivateSchoolMutation__
 *
 * To run a mutation, you first call `useActivateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSchoolMutation, { data, loading, error }] = useActivateSchoolMutation({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useActivateSchoolMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSchoolMutationResult, ActivateSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSchoolMutationResult, ActivateSchoolMutationVariables>(ActivateSchoolDocument, options);
      }
export type ActivateSchoolMutationHookResult = ReturnType<typeof useActivateSchoolMutation>;